interface SectionHeaderProps {
  kicker: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  tone?: "ink" | "paper";
}

export default function SectionHeader({
  kicker,
  title,
  desc,
  align = "left",
  tone = "ink",
}: SectionHeaderProps) {
  const centered = align === "center";
  const textMain = tone === "paper" ? "text-background-50" : "text-foreground-950";
  const textSub = tone === "paper" ? "text-background-200/90" : "text-foreground-600";

  return (
    <div className={`max-w-2xl ${centered ? "mx-auto text-center" : ""}`}>
      <p
        className={`inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium tracking-wide text-secondary-800 ${tone === "paper" ? "bg-background-100/10 text-background-100" : ""}`}
      >
        <span className="inline-block h-1.5 w-1.5 rounded-full bg-accent-500"></span>
        {kicker}
      </p>
      <h2
        className={`mt-4 text-2xl font-semibold leading-snug md:text-[2rem] md:leading-[1.3] ${textMain}`}
      >
        {title}
      </h2>
      {desc && (
        <p className={`mt-4 text-[15px] leading-relaxed ${textSub}`}>{desc}</p>
      )}
    </div>
  );
}